import { render, staticRenderFns } from "./StaticManagement.vue?vue&type=template&id=ad5ce27c"
import script from "./StaticManagement.vue?vue&type=script&lang=js"
export * from "./StaticManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports